import { ds } from "js/core/models/dataService";
import { $ } from "js/vendor";
import { app } from "js/namespaces";
import log from "js/core/logger";
import { SideBarCanvasModifier } from "common/constants";

import { SideBar } from "js/editor/ui";
import { handleEditSharedSlide } from "js/editor/editShareSlide";

import MediumEditor from "medium-editor";
import "medium-editor/dist/css/medium-editor.min.css";
import "medium-editor/dist/css/themes/default.min.css";

export const SpeakerNotes = SideBar.extend({
    fullScreen: false,
    className: "speaker_notes",
    type: "SpeakerNotes",
    isResizable: true,
    preventCanvasEditingWhenOpen: false,

    initialize: function({ editor }) {
        SideBar.prototype.initialize.call(this, {});

        this.editor = editor;
    },

    getTitle: function() {
        return "Speaker Notes";
    },

    getPanelHeight: function() {
        return 200;
    },

    getCanvasModifier: function() {
        return SideBarCanvasModifier.SCALE;
    },

    isCurrentSlideReadOnly: function() {
        if (!this.currentSlide) {
            return null;
        }

        return this.editor.checkIfSharedSlideIsReadOnly(this.currentSlide);
    },

    setup: function() {
        this.listenTo(ds.selection, "change:slide", (selection, slide) => {
            if (this.textEditor) {
                this.textEditor.destroy();
            }
            this.currentSlide = slide;
            this.renderContents();
        });

        this.currentSlide = ds.selection.slide;
    },

    renderContents: function() {
        this.$contents.empty();
        this.$notes = this.$contents.addEl($.div("speaker-notes-text", "Type your speaker notes"));

        if (this.currentSlide) {
            const slideId = this.currentSlide.id;
            this.currentSlide.load()
                .then(() => {
                    if (this.currentSlide?.id !== slideId) {
                        // Slide changed, no need to proceed
                        return;
                    }
                    this.textEditor = new MediumEditor(this.$notes[0], {
                        toolbar: {
                            buttons: ["bold", "italic", "underline", "strikethrough", {
                                name: "unorderedlist",
                                classList: ["norderedlist"]
                            }, {
                                name: "orderedlist",
                                classList: ["orderedlist"]
                            }],
                            static: true,
                            sticky: true,
                            updateOnEmptySelection: true,
                            diffTop: -20
                        },
                        paste: {
                            cleanPastedHTML: true
                        },
                        placeholder: {
                            text: "Type your speaker notes",
                            hideOnClick: true
                        },
                        disableEditing: this.isCurrentSlideReadOnly()
                    });

                    this.textEditor.setContent(this.currentSlide.get("slide_notes") || "", 0);

                    if (!this.isCurrentSlideReadOnly()) {
                        this.textEditor.subscribe("editableInput", (event, editable) => {
                            this.currentSlide.update({ slide_notes: this.textEditor.getContent(0) });
                        });

                        this.textEditor.subscribe("focus", () => {
                            app.currentCanvas.lockSlideForCollaborators(120);
                        });
                        this.textEditor.subscribe("blur", () => {
                            if (app.currentCanvas.isLockedForCollaborators()) {
                                app.currentCanvas.unlockSlideForCollaborators();
                            }
                        });

                        // insteaf of using font-awesome, just override the html with the required icon
                        // medium-editor has contentDefault and contentFA which is basically selecting
                        // either font awesome icons or text, without the option of custom icons
                        $(".norderedlist").html('<i class="micon">format_list_bulleted</i>');
                        $(".orderedlist").html('<i class="micon">format_list_numbered</i>');
                        this.$el.find(".contents > .speaker-notes-text").focus();
                    } else if (this.currentSlide.isLibrarySlide()) {
                        this.$notes.on("click", () => {
                            handleEditSharedSlide();
                        });
                    }
                })
                .catch(err => log.error(err));
        }
    },

    close: function() {
        $(window).off("keydown.sidebar");
        this.textEditor.destroy();
        this.editor.hideSpeakerNotes(true);
    }
});
